import React, { useReducer } from "react";
import { Outlet, useLocation, useOutlet } from "react-router-dom";
import { Sidebar } from "../../shared/layout/Sidebar/Sidebar";
import { ToastContainer } from "react-toastify";
import AuthContext from "../../shared/services/providers/auth.context";
import Footer from "./../../shared/layout/footer/footer";
const Main = () => {
  const outlet = useOutlet();
  const location = useLocation();

  // 'location.pathname' contains the current route
  const currentRoute = location.pathname;
  return (
    <>
      <div className="site-wrapper">
        <div className="top-wrap">
          {<Sidebar />}
          <div className="main-content" id="home">
            {outlet}
          </div>
        </div>
      </div>
      <ToastContainer />
      {/* <Footer /> */}
    </>
  );
};
export { Main };
